import React from 'react';

import { DOCUMENT_CHECKLIST_ITEM_STATES } from '../../constants/DocumentChecklistItemConstants';
import { LISTING_OFFER_CHANNELS } from '../../constants/ListingOfferConstants';
import { IDocumentChecklistItem, IRequestStatusMap, ListingOfferChannel } from '../../declarations';
import SectionCard from '../common/SectionCard/SectionCard';
import SectionCardContent from '../common/SectionCard/SectionCardContent';
import FileUploadRow from './FileUploadRow';

export interface IContractDocumentsSectionProps {
  additionalDocumentTypes: string[];
  channel: ListingOfferChannel;
  documentChecklistItems: IDocumentChecklistItem[];
  onDocumentDownload: (id: number) => void;
  onDocumentRemove: (id: number) => void;
  onDocumentSave: (
    name: string,
    documentType: string,
    fileBase64DataUrl: string,
    requestId: number,
    checklistItemId?: number,
  ) => void;
  removeChecklistDocumentRequests: IRequestStatusMap;
  uploadChecklistDocumentRequests: IRequestStatusMap;
}

export default class ContractDocumentsSection extends React.PureComponent<
  IContractDocumentsSectionProps
> {
  public render(): JSX.Element {
    const {
      additionalDocumentTypes,
      channel,
      documentChecklistItems,
      onDocumentDownload,
      onDocumentRemove,
      onDocumentSave,
      removeChecklistDocumentRequests,
      uploadChecklistDocumentRequests,
    } = this.props;
    const isDirectBuyer = LISTING_OFFER_CHANNELS.direct === channel;

    return (
      <SectionCard headerText="Transaction Documents" id="documents-section">
        <SectionCardContent>
          {isDirectBuyer
            ? 'Your Opendoor team will upload completed documents here.'
            : 'Please upload the following documents. Once uploaded, each document will be ' +
              'marked for review for your Opendoor Closing Manager or Experience Partner, and they will ' +
              'take appropriate action.'}
        </SectionCardContent>
        <SectionCardContent>
          {documentChecklistItems
            .filter(
              item =>
                !isDirectBuyer ||
                item.state === DOCUMENT_CHECKLIST_ITEM_STATES.executed ||
                item.state === DOCUMENT_CHECKLIST_ITEM_STATES.received,
            )
            .map(item => {
              return (
                <FileUploadRow
                  documentChecklistItem={item}
                  key={item.id}
                  onDocumentDownload={onDocumentDownload}
                  onDocumentRemove={onDocumentRemove}
                  onDocumentSave={onDocumentSave}
                  removeChecklistDocumentRequests={removeChecklistDocumentRequests}
                  uploadChecklistDocumentRequests={uploadChecklistDocumentRequests}
                />
              );
            })}
          {!isDirectBuyer && (
            <FileUploadRow
              additionalDocumentTypes={additionalDocumentTypes}
              onDocumentDownload={onDocumentDownload}
              onDocumentRemove={onDocumentRemove}
              onDocumentSave={onDocumentSave}
              removeChecklistDocumentRequests={removeChecklistDocumentRequests}
              uploadChecklistDocumentRequests={uploadChecklistDocumentRequests}
            />
          )}
        </SectionCardContent>
      </SectionCard>
    );
  }
}
